import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { ROLES } from '@/modules/base/util/constants'

import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import ProfileDetailsTooltip from '@/modules/layout/components/submenu/profie-section/profile-details-tooltip'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { switchTenant } from '@/redux/ducks/user/info'
import IconRedirect from 'assets/images/icons/redirect.svg'
import lang from '@/lang'
import theme from '@/theme'
import { useNavigate } from 'react-router'

const ProfileSection = () => {
  const navigate = useNavigate()
  const classes = useStyles()
  const dispatch = useDispatch()
  const { info, info: { activeTenant: user, activeTenant: { tenantCollaborationId }, tenants } } = useSelector(state => state.user)

  const isTaxConsultantSubscription = (sub) => sub.type === 'taxconsultant'
  const tenantSubscriptions = tenants.flatMap(t => t.subscriptions)
  const userHasTaxTenant = tenantSubscriptions.some(isTaxConsultantSubscription)
  const currentTenantIsTaxTenant = user?.subscriptions.some(isTaxConsultantSubscription)
  const userIsTaxConsultant = info?.roles?.includes(ROLES.TAX_CONSULTANT_ROLE) || userHasTaxTenant

  const switchToTaxConsultant = () => {
    const taxConsultantTenant = tenants.find(tenant =>
      tenant.subscriptions.some(isTaxConsultantSubscription),
    )
    dispatch(switchTenant(taxConsultantTenant, () => {
      navigate('/')
    }))
  }

  const shortCompanyName = (name) => {
    const MAX_LENGTH = 22
    if (name.length <= MAX_LENGTH) return name
    return `${name.slice(0, MAX_LENGTH)}...`
  }

  return (
    !currentTenantIsTaxTenant && userIsTaxConsultant && <div className={classes.container}>
      <RichTooltip content={<ProfileDetailsTooltip user={user} tenantCollaborationId={tenantCollaborationId} />} placement='right' offsetY={-70} width='fit-content'>
        <div>
          <small className={classes.text}>{lang.menu.profileSection.heading}</small>
          <p className={classes.name}>{user?.companyName ? shortCompanyName(user?.companyName) : lang.menu.profileSection.noCompanyName}</p>
          { userHasTaxTenant && <a className={classes.text} onClick={switchToTaxConsultant}>
            <SVGIcon svg={IconRedirect} height={10} width={10} fill={theme.primary} className={classes.redirectIcon} />
            {lang.menu.profileSection.viewTaxConsultant}
          </a>}
        </div>
      </RichTooltip>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  text: {
    fontSize: theme.fontSizes.tiny,
    color: '#aec7e3',
  },
  name: {
    fontSize: theme.fontSizes.smaller,
    color: theme.white,
    margin: 0,
  },
  redirectIcon: {
    marginRight: 5,
  },
}))

export default ProfileSection
